<template>
  <div class="md-layout">
    <!-- PRACTICE -->
    <div class="md-layout-item md-size-100">
      <md-field
        :class="[
          { 'md-valid': !errors.has('practice') && touched.practice },
          { 'md-form-group': true },
          { 'md-error': errors.has('practice') }
        ]"
      >
        <md-icon>business</md-icon>
        <label>Name: Business / Practice</label>
        <md-input v-validate="'required'" v-model="practice" data-vv-name="practice" type="text" name="practice" />
        <slide-y-down-transition>
          <md-icon v-show="errors.has('practice')" class="error">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon v-show="!errors.has('practice') && touched.practice" class="success">done</md-icon>
        </slide-y-down-transition>
      </md-field>
    </div>

    <!-- BOARD CERTIFIED -->
    <div class="md-layout-item md-size-50 md-small-size-100">
      <md-field
        :class="[
          { 'md-error': errors.has('boardCertified') },
          { 'md-form-group': true },
          { 'md-valid': !errors.has('boardCertified') && touched.boardCertified }
        ]"
      >
        <md-icon>verified</md-icon>
        <label for="boardCertified">Are you Board Certified?</label>
        <md-select
          v-validate="'required'"
          v-model="boardCertified"
          style="margin-left: 10px"
          name="boardCertified"
          data-vv-name="boardCertified"
        >
          <md-option value="Yes">Yes, I am Board Certified</md-option>
          <md-option value="No">No, I am not Board Certified</md-option>
          <md-option value="Pending">My Board Certification is pending</md-option>
        </md-select>
      </md-field>
    </div>

    <!-- CERTIFICATION DATE -->
    <div class="md-layout-item md-size-50 md-small-size-50">
      <md-field
        :class="[
          { 'md-valid': !errors.has('certDate') && touched.certDate && boardCertified != 'No' },
          { 'md-form-group': true },
          { 'md-error': errors.has('certDate') }
        ]"
      >
        <md-icon>today</md-icon>
        <label for="certDate">Certification Date</label>
        <md-input
          v-validate="{ required: boardCertified.toLowerCase() === 'yes' }"
          id="certDate"
          v-model="certDate"
          style="border-bottom: solid 1px lightgray !important"
          placeholder=" "
          data-vv-name="certDate"
          name="certDate"
          type="date"
        />
      </md-field>
    </div>

    <!-- Insurance -->
    <div
      :class="[
        { 'md-layout-item': true },
        { 'space-right-phone': true },
        { 'md-size-40': isPhone },
        { 'md-size-50': !isPhone }
      ]"
      class="md-layout-item md-size-50 md-small-size-50"
      @click="focus('insurance')"
    >
      <md-field
        :class="[
          { 'md-valid': !errors.has('insurance') && touched.insurance },
          { 'md-form-group': true },
          { 'md-error': errors.has('insurance') }
        ]"
      >
        <md-icon>emergency</md-icon>
        <label>Insurance</label>
        <md-select
          id="insurance-select"
          ref="insuranceInput"
          v-model="insurance"
          style="margin-left: 20px"
          data-vv-name="insurance"
          type="text"
          name="insurance"
          md-dense
        >
          <md-option
            v-for="(insurance, index) in insurances"
            :key="insurance.LookupId"
            :id="insurance + '-insurance'"
            :value="insurance.LookupId"
            :md-value="insurance"
            >{{ insurance.DisplayValue }}</md-option
          >
          <md-option id="other-insurance" key="other" value="other"> Other</md-option>
        </md-select>
        <slide-y-down-transition>
          <md-icon v-show="errors.has('insurance')" class="error">close</md-icon>
        </slide-y-down-transition>
        <slide-y-down-transition>
          <md-icon v-show="!errors.has('insurance') && touched.insurance" class="success" style="margin-right: 15px"
            >done</md-icon
          >
        </slide-y-down-transition>
      </md-field>
    </div>

    <!-- Insurance OTHER -->
    <div v-if="insurance == 'other'" class="md-layout-item md-size-50 md-size-50">
      <md-field
        :class="[
          { 'md-error': errors.has('insuranceOther') },
          { 'md-form-group': true },
          { 'md-valid': !errors.has('insuranceOther') && touched.insuranceOther }
        ]"
      >
        <md-icon>emergency</md-icon>
        <label>Insurance Other</label>
        <md-input
          v-validate="'required'"
          v-model="insuranceOther"
          data-vv-name="insuranceOther"
          type="text"
          name="insuranceOther"
        />
      </md-field>
    </div>

    <!-- CAQH -->
    <div class="md-layout-item md-size-100 mt-4 md-small-size-100">
      <md-field
        :class="[
          { 'md-error': errors.has('CAQH') },
          { 'md-form-group': true },
          { 'md-valid': !errors.has('CAQH') && touched.CAQH }
        ]"
      >
        <md-icon>verified_user</md-icon>
        <label>CAQH Number #</label>
        <md-input v-model="CAQH" data-vv-name="CAQH" type="text" name="CAQH" />
      </md-field>

      <!-- NPI -->
      <md-field
        :class="[
          { 'md-error': errors.has('NPI') },
          { 'md-form-group': true },
          { 'md-valid': !errors.has('NPI') && touched.NPI }
        ]"
      >
        <md-icon>verified_user</md-icon>
        <label>NPI Number #</label>
        <md-input v-model="NPI" data-vv-name="NPI" type="text" name="NPI" />
      </md-field>
    </div>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions"
import { mapGetters, mapActions } from "vuex"
import $ from "jquery"

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      insurances: [],
      insurance: "",
      boardCertified: "",
      certDate: null,
      disabledDates: (date) => {
        const now = new Date()
        return date > now
      },
      CAQH: "",
      NPI: "",
      practice: "",
      insuranceOther: "",
      touched: {
        boardCertified: false,
        certDate: false,
        CAQH: false,
        NPI: false,
        insurance: false,
        insuranceOther: false
      }
    }
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["rdCredentials", "isPhone"])
  },
  watch: {
    boardCertified() {
      if (this.boardCertified.toLowerCase() != "yes") {
        this.certDate = ""
      }
    },
    certDate() {
      this.touched.certDate = true
    },
    CAQH() {
      this.touched.CAQH = true
    },
    NPI() {
      this.touched.NPI = true
    },
    practice() {
      this.touched.practice = true
    },
    insurance() {
      this.touched.insurance = true
    }
  },
  mounted() {
    this.defineLookups()
  },
  methods: {
    ...mapActions(["listLookupsByMasterName"]),
    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },
    async defineLookups() {
      try {
        this.insurances = await this.fetchLookupByName("Insurance")
        if (this.isEdit) {
          this.fillCredentialData()
        }
      } catch (error) {
        console.error(error)
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString)
      // Ensures leading zeros in month/day
      const yyyy = date.getFullYear()
      const mm = String(date.getMonth() + 1).padStart(2, "0")
      const dd = String(date.getDate()).padStart(2, "0")
      return `${yyyy}-${mm}-${dd}`
    },
    fillCredentialData() {
      const insuranceExistInLookup = this.insurances.find(
        (insurance) => insurance.LookupId.toString() == this.rdCredentials.insurance.toString()
      )

      this.boardCertified = this.rdCredentials.ruCertified || false
      this.CAQH = this.rdCredentials.CAQH || ""
      this.NPI = this.rdCredentials.NPI || ""
      this.practice = this.rdCredentials.practice || ""
      this.certDate = this.rdCredentials.certDate ? this.formatDate(this.rdCredentials.certDate) : null
      this.insurance = insuranceExistInLookup ? this.rdCredentials.insurance : "other"
      if (this.insurance == "other") {
        this.insuranceOther = this.rdCredentials.insurance
      }
    },
    validate() {
      this.storeValues()
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res)
        return res
      })
    },
    storeValues() {
      this.rdCredentials.ruCertified = this.boardCertified
      this.rdCredentials.certDate = this.certDate
      this.rdCredentials.CAQH = this.CAQH
      this.rdCredentials.NPI = this.NPI
      this.rdCredentials.practice = this.practice
      this.rdCredentials.insurance = this.insurance == "other" ? this.insuranceOther : this.insurance
    },
    focus(type) {
      let el = $("#" + type + "-select")
      el.focus()
    }
  }
}
</script>
<style>
:root {
  --gray: #999;
  --blue: #0074d9;
  --color: #333;
  --background-color: #fff;
  --border: 1px solid #eee;
}

.md-menu-content {
  z-index: 9998 !important;
}
</style>
